import React, { useEffect, useState } from "react";
import { UI_DEFAULTS, UI_FIELDS } from "@/lib/uiTexts";
import { GALLERY_DEFAULTS } from "@/lib/collections";

function UploadBtn({ onDone, label = "Subir foto" }) {
  const ref = React.useRef();
  const [busy, setBusy] = useState(false);
  return (<>
    <input ref={ref} type="file" accept="image/*" className="hidden" onChange={async (e) => {
      const file = e.target.files?.[0]; if (!file) return;
      setBusy(true);
      try {
        const fd = new FormData(); fd.append("file", file);
        const r = await api.post("/admin/upload", fd);
        onDone(r.data.url);
      } catch (err) { toast.error(errMsg(err)); }
      setBusy(false); if (ref.current) ref.current.value = "";
    }} />
    <button type="button" data-testid="upload-photo-btn" onClick={() => ref.current?.click()} className="btn-outline-ink px-3 py-1.5 dossier-label text-[10px]">{busy ? "…" : label}</button>
  </>);
}
import { toast } from "sonner";
import { Plus, X, Trash2, Users } from "lucide-react";
import api, { formatARS, errMsg, CATEGORIES, API } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import ProductEditor from "@/pages/admin/ProductEditor";

const TABS = [["metricas", "Métricas"], ["piezas", "Piezas"], ["lanzamiento", "Lanzamiento"], ["eventos", "Eventos"], ["liberaciones", "Liberaciones"], ["envios", "Envíos"], ["pedidos", "Pedidos"], ["emails", "Emails"], ["facturacion", "Facturación"], ["contenido", "Contenido"], ["ajustes", "Ajustes"]];
const field = "mt-1.5 bg-[#F4F4F3] border-[#C4C7CD] text-[#171719]";
const lbl = "dossier-label text-[#565A61]";

export default function Admin() {
  const [tab, setTab] = useState("metricas");

  return (
    <div className="px-4 sm:px-8 lg:px-16 py-10">
      <div className="dossier-label text-[#858A91] mb-2">Laboratorio · administración</div>
      <h1 className="font-display font-extrabold uppercase tracking-tight text-4xl text-[#171719] mb-8">Panel</h1>

      <div className="flex gap-2 border-b border-[#C9CBD1] mb-8 overflow-x-auto no-scrollbar">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`admin-tab-${k}`} onClick={() => setTab(k)} className={`dossier-label px-4 py-3 border-b-2 transition-colors whitespace-nowrap ${tab === k ? "border-[#171719] text-[#171719]" : "border-transparent text-[#565A61] hover:text-[#565A61]"}`}>{l}</button>
        ))}
      </div>

      {tab === "metricas" && <MetricsTab />}
      {tab === "piezas" && <PiezasTab />}
      {tab === "eventos" && <EventosTab />}
      {tab === "liberaciones" && <LiberacionesTab />}
      {tab === "envios" && <EnviosTab />}
      {tab === "pedidos" && <PedidosTab />}
      {tab === "emails" && <EmailsTab />}
      {tab === "lanzamiento" && <LanzamientoTab />}
      {tab === "facturacion" && <FacturacionTab />}
      {tab === "contenido" && <ContenidoTab />}
      {tab === "ajustes" && <AjustesTab />}
    </div>
  );
}

function PiezasTab() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/products").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("¿Eliminar esta pieza?")) return;
    try { await api.delete(`/admin/products/${id}`); toast.success("Pieza eliminada"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div>
      <button data-testid="new-product-button" onClick={() => setEditing({})} className="btn-ink px-6 py-3 dossier-label inline-flex items-center gap-2 mb-6"><Plus size={16} /> Nueva pieza</button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((p) => (
          <div key={p.id} data-testid={`admin-product-${p.id}`} onClick={() => setEditing(p)} className="museum-frame p-4 flex gap-4 cursor-pointer hover-lift">
            <div className="w-16 h-20 bg-[#CFD1D6] overflow-hidden shrink-0">{p.images?.[0] && <img src={p.images[0]} alt="" className="w-full h-full object-cover" />}</div>
            <div className="flex-1 min-w-0">
              <div className="dossier-label text-[#565A61]">{p.design_code} · {CATEGORIES.find((c) => c.key === p.category)?.label}</div>
              <h3 className="font-display font-bold uppercase tracking-tight text-[#171719] truncate">{p.name}</h3>
              <div className="flex items-center gap-3 mt-1 text-xs">
                <span className={`dossier-label ${p.status === "published" ? "text-[#4C7A51]" : p.status === "draft" ? "text-[#565A61]" : "text-[#565A61]"}`}>{p.status}</span>
                <span className="text-[#565A61]">{p.price != null ? formatARS(p.price) : "sin precio"}</span>
                <span data-testid={`stock-info-${p.id}`} className="text-[#565A61]">{p.available_total} libre{p.available_total === 1 ? "" : "s"} · {p.sold_total || 0} vendida{(p.sold_total || 0) === 1 ? "" : "s"}</span>
                {p.available_total === 0 && p.units_total > 0 && <span className="dossier-label bg-[#171719] text-[#F4F4F3] px-2 py-0.5">sin stock</span>}
                {p.vip && <span className="dossier-label text-[#565A61]">VIP</span>}
              </div>
            </div>
            <button data-testid={`delete-product-${p.id}`} onClick={(e) => del(p.id, e)} className="dossier-label text-[#565A61] hover:text-[#56677A] self-start">eliminar</button>
          </div>
        ))}
      </div>
      {editing && <ProductEditor product={editing.id ? editing : null} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
    </div>
  );
}

function PedidosTab() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const retryInvoice = async (id) => { try { await api.post(`/admin/orders/${id}/invoice/retry`); toast.success("Reprocesando factura…"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const INV = { pending: "Factura pendiente", processing: "Facturando…", authorized: "Factura autorizada", pdf_ready: "Factura PDF lista", emailed: "Factura enviada", rejected: "Error de factura", disabled: "Facturación off" };
  return (
    <div className="flex flex-col gap-3">
      {orders.length === 0 && <p className="text-[#565A61]">Sin pedidos todavía.</p>}
      {orders.map((o) => (
        <div key={o.id} data-testid={`admin-order-${o.id}`} className="museum-frame p-5">
          <div className="flex items-center justify-between">
            <div>
              <div className="font-mono2 text-xs text-[#2E2E31]">{o.id}</div>
              <div className="text-sm text-[#565A61] mt-1">{o.guest_name} · {o.guest_email}</div>
            </div>
            <div className="text-right">
              <span className={`dossier-label px-3 py-1 ${o.status === "paid" ? "bg-[#1C241D] text-[#4C7A51]" : "bg-[#2A2A2A] text-[#E8E9EB]"}`}>{o.status}</span>
              <div className="text-[#171719] mt-2">{formatARS(o.total)}</div>
              {o.status === "paid" && o.invoice && (
                <div className="mt-1 flex items-center justify-end gap-2">
                  <span className={`dossier-label text-[10px] ${o.invoice.status === "emailed" ? "text-[#4C7A51]" : o.invoice.status === "rejected" ? "text-[#565A61]" : "text-[#565A61]"}`}>
                    {INV[o.invoice.status] || o.invoice.status}{o.invoice.numero ? ` · Nº ${String(o.invoice.numero).padStart(8, "0")}` : ""}
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="mt-3 pt-3 border-t border-[#C9CBD1] text-xs text-[#565A61]">
            {o.items.map((i, idx) => <div key={i.unit_id || idx}>{i.name}{i.size ? ` · T${i.size}` : ""}{i.unit_code ? ` · ${i.unit_code}` : ""}</div>)}
            <div className="mt-1 text-[#565A61]">Entrega: {o.shipping_method || "—"} {o.shipping_address && `· ${o.shipping_address}`}</div>
          </div>
          {o.status === "paid" && o.invoice && ["pending", "rejected", "disabled"].includes(o.invoice.status) && (
            <button data-testid={`invoice-retry-${o.id}`} onClick={() => retryInvoice(o.id)} className="dossier-label text-[10px] text-[#565A61] hover:text-[#171719] underline mt-2">Reintentar factura</button>
          )}
          {o.status === "paid" && o.invoice && ["pdf_ready", "emailed"].includes(o.invoice.status) && (
            <a href={`${API}/orders/${o.id}/invoice.pdf`} target="_blank" rel="noreferrer" data-testid={`invoice-pdf-${o.id}`} className="dossier-label text-[10px] text-[#565A61] hover:text-[#171719] underline mt-2 inline-block">Ver factura PDF</a>
          )}
          {o.status === "paid" && (o.kind || "pieces") !== "event" && <ShippingEditor order={o} onSaved={load} />}
        </div>
      ))}
    </div>
  );
}

function ShippingEditor({ order, onSaved }) {
  const [s, setS] = useState({ status: order.shipping_status || "pendiente", carrier: order.carrier || "", tracking_number: order.tracking_number || "", tracking_url: order.tracking_url || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.put(`/admin/orders/${order.id}/shipping`, s); toast.success(s.status === "enviado" ? "Marcado como enviado · email enviado" : "Envío actualizado"); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-3 pt-3 border-t border-[#C9CBD1]">
      <div className="dossier-label text-[#565A61] mb-2">Envío y seguimiento</div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        <select data-testid={`ship-status-${order.id}`} value={s.status} onChange={(e) => setS({ ...s, status: e.target.value })} className={`${field} mt-0 h-9 px-2 rounded-md border text-sm`}>
          <option value="pendiente">Preparando</option>
          <option value="enviado">Enviado</option>
          <option value="entregado">Entregado</option>
        </select>
        <Input className={`${field} mt-0 h-9`} placeholder="Transportista" value={s.carrier} onChange={(e) => setS({ ...s, carrier: e.target.value })} />
        <Input data-testid={`ship-tracking-${order.id}`} className={`${field} mt-0 h-9`} placeholder="Nº seguimiento" value={s.tracking_number} onChange={(e) => setS({ ...s, tracking_number: e.target.value })} />
        <Input className={`${field} mt-0 h-9`} placeholder="URL seguimiento (https)" value={s.tracking_url} onChange={(e) => setS({ ...s, tracking_url: e.target.value })} />
      </div>
      <button data-testid={`ship-save-${order.id}`} onClick={save} disabled={busy} className="btn-outline-ink px-5 py-2 dossier-label mt-2 disabled:opacity-60">{busy ? "Guardando…" : "Guardar envío"}</button>
    </div>
  );
}

function EventosTab() {
  const [events, setEvents] = useState([]);
  const [editing, setEditing] = useState(null);
  const [regsFor, setRegsFor] = useState(null);

  const load = () => api.get("/admin/events").then((r) => setEvents(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("¿Eliminar este evento?")) return;
    try { await api.delete(`/admin/events/${id}`); toast.success("Evento eliminado"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div>
      <button data-testid="new-event-button" onClick={() => setEditing({})} className="btn-ink px-6 py-3 dossier-label inline-flex items-center gap-2 mb-6"><Plus size={16} /> Nuevo evento</button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {events.map((ev) => (
          <div key={ev.id} data-testid={`admin-event-${ev.id}`} onClick={() => setEditing(ev)} className="museum-frame p-4 flex gap-4 cursor-pointer hover-lift">
            <div className="w-16 h-16 bg-[#CFD1D6] overflow-hidden shrink-0">{ev.image && <img src={ev.image} alt="" className="w-full h-full object-cover" />}</div>
            <div className="flex-1 min-w-0">
              <div className="dossier-label text-[#565A61]">{ev.type} · {ev.date || "s/fecha"}</div>
              <h3 className="font-display font-bold uppercase tracking-tight text-[#171719] truncate">{ev.title}</h3>
              <div className="flex items-center gap-3 mt-1 text-xs">
                <span className={`dossier-label ${ev.status === "published" ? "text-[#4C7A51]" : "text-[#565A61]"}`}>{ev.status}</span>
                <span className="text-[#565A61]">{ev.price != null ? formatARS(ev.price) : "libre"}</span>
                <span className="text-[#565A61]">{ev.registered_count} anotad{ev.capacity ? `/${ev.capacity}` : "@s"}</span>
              </div>
              <div className="flex gap-3 mt-2">
                <button data-testid={`event-regs-${ev.id}`} onClick={(e) => { e.stopPropagation(); setRegsFor(ev); }} className="dossier-label text-[#565A61] hover:text-[#171719] inline-flex items-center gap-1"><Users size={12} /> inscriptas</button>
                <button onClick={(e) => del(ev.id, e)} className="dossier-label text-[#565A61] hover:text-[#56677A]">eliminar</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {editing && <EventEditor event={editing.id ? editing : null} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
      {regsFor && <RegsModal event={regsFor} onClose={() => setRegsFor(null)} />}
    </div>
  );
}

function EventEditor({ event, onClose, onSaved }) {
  const [f, setF] = useState({ title: "", type: "desfile", description: "", date: "", location: "", image: "", price: "", capacity: "", status: "draft" });
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (event) setF({ ...f, ...event, price: event.price ?? "", capacity: event.capacity ?? "", image: event.image || "" }); }, [event]);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const save = async () => {
    if (!f.title) return toast.error("El título es obligatorio");
    setSaving(true);
    const payload = { ...f, price: f.price === "" ? null : Number(f.price), capacity: f.capacity === "" ? null : Number(f.capacity), image: f.image || null };
    try {
      if (event?.id) await api.put(`/admin/events/${event.id}`, payload);
      else await api.post("/admin/events", payload);
      toast.success("Evento guardado"); onSaved();
    } catch (e) { toast.error(errMsg(e)); }
    setSaving(false);
  };
  return (
    <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm overflow-y-auto" data-testid="event-editor">
      <div className="min-h-screen flex items-start justify-center p-4 py-10">
        <div className="bg-[#F4F4F3] border border-[#C4C7CD] w-full max-w-xl">
          <div className="flex items-center justify-between p-5 border-b border-[#C9CBD1]">
            <h2 className="font-display font-bold uppercase tracking-tight text-xl text-[#171719]">{event?.id ? "Editar evento" : "Nuevo evento"}</h2>
            <button onClick={onClose} className="text-[#565A61] hover:text-[#171719]"><X size={20} /></button>
          </div>
          <div className="p-5 space-y-4">
            <div><Label className={lbl}>Título</Label><Input data-testid="ev-title" className={field} value={f.title} onChange={(e) => set("title", e.target.value)} /></div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label className={lbl}>Tipo</Label>
                <select data-testid="ev-type" value={f.type} onChange={(e) => set("type", e.target.value)} className={`${field} w-full h-10 px-3 rounded-md border`}>
                  <option value="desfile">Desfile</option><option value="lanzamiento">Lanzamiento</option>
                  <option value="exposicion">Exposición</option><option value="presentacion">Presentación</option>
                </select>
              </div>
              <div>
                <Label className={lbl}>Estado</Label>
                <select data-testid="ev-status" value={f.status} onChange={(e) => set("status", e.target.value)} className={`${field} w-full h-10 px-3 rounded-md border`}>
                  <option value="draft">Borrador</option><option value="published">Publicado</option>
                </select>
              </div>
              <div><Label className={lbl}>Fecha (texto)</Label><Input className={field} value={f.date} onChange={(e) => set("date", e.target.value)} placeholder="A confirmar" /></div>
              <div><Label className={lbl}>Lugar</Label><Input className={field} value={f.location} onChange={(e) => set("location", e.target.value)} /></div>
              <div><Label className={lbl}>Precio ARS (vacío = libre)</Label><Input data-testid="ev-price" type="number" className={field} value={f.price} onChange={(e) => set("price", e.target.value)} /></div>
              <div><Label className={lbl}>Cupos (vacío = sin tope)</Label><Input type="number" className={field} value={f.capacity} onChange={(e) => set("capacity", e.target.value)} /></div>
            </div>
            <div><Label className={lbl}>URL de imagen</Label><Input className={field} value={f.image} onChange={(e) => set("image", e.target.value)} placeholder="https://…" /></div>
            <div><Label className={lbl}>Descripción</Label><Textarea rows={3} className={field} value={f.description} onChange={(e) => set("description", e.target.value)} /></div>
          </div>
          <div className="flex gap-3 p-5 border-t border-[#C9CBD1]">
            <button data-testid="ev-save" onClick={save} disabled={saving} className="btn-ink px-7 py-3 dossier-label disabled:opacity-60">{saving ? "Guardando…" : "Guardar evento"}</button>
            <button onClick={onClose} className="btn-outline-ink px-7 py-3 dossier-label">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function RegsModal({ event, onClose }) {
  const [regs, setRegs] = useState([]);
  useEffect(() => { api.get(`/admin/events/${event.id}/registrations`).then((r) => setRegs(r.data)).catch(() => {}); }, [event]);
  return (
    <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-[#F4F4F3] border border-[#C4C7CD] w-full max-w-lg" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b border-[#C9CBD1]">
          <h2 className="font-display font-bold uppercase tracking-tight text-lg text-[#171719]">Inscriptas · {event.title}</h2>
          <button onClick={onClose} className="text-[#565A61] hover:text-[#171719]"><X size={18} /></button>
        </div>
        <div className="p-5 max-h-[60vh] overflow-y-auto no-scrollbar">
          {regs.length === 0 ? <p className="text-[#565A61] text-sm">Sin inscripciones todavía.</p> : regs.map((r) => (
            <div key={r.id} className="flex items-center justify-between py-2.5 border-b border-[#C9CBD1] text-sm">
              <div><div className="text-[#171719]">{r.name}</div><div className="text-[#565A61] text-xs">{r.email}</div></div>
              <span className={`dossier-label px-2 py-1 ${r.status === "pagada" ? "bg-[#1C241D] text-[#4C7A51]" : r.status === "anotada" ? "bg-[#2A2A2A] text-[#E8E9EB]" : "bg-[#2A2415] text-[#b9942f]"}`}>{r.status}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function LiberacionesTab() {
  const [releases, setReleases] = useState([]);
  const [editing, setEditing] = useState(null);
  const [wlFor, setWlFor] = useState(null);

  const load = () => api.get("/admin/releases").then((r) => setReleases(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("¿Eliminar esta liberación?")) return;
    try { await api.delete(`/admin/releases/${id}`); toast.success("Liberación eliminada"); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const notify = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("¿Enviar email de novedad a toda la lista de espera?")) return;
    try { const { data } = await api.post(`/admin/releases/${id}/notify`); toast.success(`Emails enviados: ${data.sent}`); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div>
      <button data-testid="new-release-button" onClick={() => setEditing({})} className="btn-ink px-6 py-3 dossier-label inline-flex items-center gap-2 mb-6"><Plus size={16} /> Nueva liberación</button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {releases.map((r) => (
          <div key={r.id} data-testid={`admin-release-${r.id}`} onClick={() => setEditing(r)} className="museum-frame p-4 flex gap-4 cursor-pointer hover-lift">
            <div className="w-16 h-16 bg-[#CFD1D6] overflow-hidden shrink-0">{r.image && <img src={r.image} alt="" className="w-full h-full object-cover" />}</div>
            <div className="flex-1 min-w-0">
              <div className="dossier-label text-[#565A61]">{r.teaser_date || "s/fecha"}</div>
              <h3 className="font-display font-bold uppercase tracking-tight text-[#171719] truncate">{r.title}</h3>
              <div className="flex items-center gap-3 mt-1 text-xs">
                <span className={`dossier-label ${r.status === "published" ? "text-[#4C7A51]" : "text-[#565A61]"}`}>{r.status}</span>
                <span className="text-[#565A61]">{r.waitlist_count} en lista</span>
              </div>
              <div className="flex gap-3 mt-2">
                <button data-testid={`release-wl-${r.id}`} onClick={(e) => { e.stopPropagation(); setWlFor(r); }} className="dossier-label text-[#565A61] hover:text-[#171719] inline-flex items-center gap-1"><Users size={12} /> lista</button>
                <button data-testid={`release-notify-${r.id}`} onClick={(e) => notify(r.id, e)} className="dossier-label text-[#171719] hover:text-[#56677A]">avisar novedad</button>
                <button onClick={(e) => del(r.id, e)} className="dossier-label text-[#565A61] hover:text-[#56677A]">eliminar</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {editing && <ReleaseEditor release={editing.id ? editing : null} onClose={() => setEditing(null)} onSaved={() => { setEditing(null); load(); }} />}
      {wlFor && <WaitlistModalAdmin release={wlFor} onClose={() => setWlFor(null)} />}
    </div>
  );
}

function ReleaseEditor({ release, onClose, onSaved }) {
  const [f, setF] = useState({ title: "", description: "", image: "", teaser_date: "", status: "draft" });
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (release) setF({ ...f, ...release, image: release.image || "" }); }, [release]);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const save = async () => {
    if (!f.title) return toast.error("El título es obligatorio");
    setSaving(true);
    const payload = { ...f, image: f.image || null };
    try {
      if (release?.id) await api.put(`/admin/releases/${release.id}`, payload);
      else await api.post("/admin/releases", payload);
      toast.success("Liberación guardada"); onSaved();
    } catch (e) { toast.error(errMsg(e)); }
    setSaving(false);
  };
  return (
    <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm overflow-y-auto" data-testid="release-editor">
      <div className="min-h-screen flex items-start justify-center p-4 py-10">
        <div className="bg-[#F4F4F3] border border-[#C4C7CD] w-full max-w-xl">
          <div className="flex items-center justify-between p-5 border-b border-[#C9CBD1]">
            <h2 className="font-display font-bold uppercase tracking-tight text-xl text-[#171719]">{release?.id ? "Editar liberación" : "Nueva liberación"}</h2>
            <button onClick={onClose} className="text-[#565A61] hover:text-[#171719]"><X size={20} /></button>
          </div>
          <div className="p-5 space-y-4">
            <div><Label className={lbl}>Título</Label><Input data-testid="rel-title" className={field} value={f.title} onChange={(e) => set("title", e.target.value)} /></div>
            <div className="grid grid-cols-2 gap-4">
              <div><Label className={lbl}>Fecha teaser (texto)</Label><Input className={field} value={f.teaser_date} onChange={(e) => set("teaser_date", e.target.value)} placeholder="Próximamente" /></div>
              <div>
                <Label className={lbl}>Estado</Label>
                <select data-testid="rel-status" value={f.status} onChange={(e) => set("status", e.target.value)} className={`${field} w-full h-10 px-3 rounded-md border`}>
                  <option value="draft">Borrador</option><option value="published">Publicada</option>
                </select>
              </div>
            </div>
            <div><Label className={lbl}>URL de imagen</Label><Input className={field} value={f.image} onChange={(e) => set("image", e.target.value)} placeholder="https://…" /></div>
            <div><Label className={lbl}>Descripción</Label><Textarea rows={3} className={field} value={f.description} onChange={(e) => set("description", e.target.value)} /></div>
          </div>
          <div className="flex gap-3 p-5 border-t border-[#C9CBD1]">
            <button data-testid="rel-save" onClick={save} disabled={saving} className="btn-ink px-7 py-3 dossier-label disabled:opacity-60">{saving ? "Guardando…" : "Guardar liberación"}</button>
            <button onClick={onClose} className="btn-outline-ink px-7 py-3 dossier-label">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function WaitlistModalAdmin({ release, onClose }) {
  const [wl, setWl] = useState([]);
  useEffect(() => { api.get(`/admin/releases/${release.id}/waitlist`).then((r) => setWl(r.data)).catch(() => {}); }, [release]);
  return (
    <div className="fixed inset-0 z-[60] bg-black/80 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-[#F4F4F3] border border-[#C4C7CD] w-full max-w-lg" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b border-[#C9CBD1]">
          <h2 className="font-display font-bold uppercase tracking-tight text-lg text-[#171719]">Lista de espera · {release.title}</h2>
          <button onClick={onClose} className="text-[#565A61] hover:text-[#171719]"><X size={18} /></button>
        </div>
        <div className="p-5 max-h-[60vh] overflow-y-auto no-scrollbar">
          {wl.length === 0 ? <p className="text-[#565A61] text-sm">Nadie en la lista todavía.</p> : wl.map((w) => (
            <div key={w.id} className="flex items-center justify-between py-2.5 border-b border-[#C9CBD1] text-sm">
              <div><div className="text-[#171719]">{w.name}</div><div className="text-[#565A61] text-xs">{w.email}{w.size ? ` · talle ${w.size}` : ""}</div></div>
              {w.notified && <span className="dossier-label text-[#4C7A51]">avisada</span>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function EnviosTab() {
  const [s, setS] = useState(null);
  const [carriers, setCarriers] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setS({ flat_cost: 0, free_threshold: "", pickup_enabled: true, shipping_zones: [], origin_postal_code: "", default_weight_kg: 1, ...r.data, free_threshold: r.data.free_threshold ?? "" })).catch(() => {});
    api.get("/admin/carriers").then((r) => setCarriers(r.data)).catch(() => {});
  }, []);

  const saveShipping = async () => {
    const payload = { ...s, free_threshold: s.free_threshold === "" ? null : Number(s.free_threshold), flat_cost: Number(s.flat_cost || 0), default_weight_kg: Number(s.default_weight_kg || 1) };
    try { await api.put("/admin/settings", payload); toast.success("Envíos actualizados"); } catch (e) { toast.error(errMsg(e)); }
  };
  const saveCarriers = async () => {
    const out = {};
    for (const k of Object.keys(carriers.fields)) out[k] = { enabled: !!carriers[k]?.enabled, credentials: carriers[k]?.credentials || {} };
    try { await api.put("/admin/carriers", out); toast.success("Credenciales guardadas"); } catch (e) { toast.error(errMsg(e)); }
  };
  const setZone = (i, k, v) => { const z = [...s.shipping_zones]; z[i] = { ...z[i], [k]: v }; setS({ ...s, shipping_zones: z }); };

  if (!s || !carriers) return <p className="dossier-label text-[#565A61]">cargando…</p>;

  return (
    <div className="max-w-2xl space-y-10">
      <div className="space-y-4">
        <h3 className="font-display font-bold uppercase tracking-tight text-xl text-[#171719]">Costos de envío</h3>
        <div className="grid grid-cols-2 gap-4">
          <div><Label className={lbl}>Costo base ARS</Label><Input data-testid="ship-flat" type="number" className={field} value={s.flat_cost} onChange={(e) => setS({ ...s, flat_cost: e.target.value })} /></div>
          <div><Label className={lbl}>Envío gratis desde ARS (vacío = nunca)</Label><Input type="number" className={field} value={s.free_threshold} onChange={(e) => setS({ ...s, free_threshold: e.target.value })} /></div>
        </div>
        <label className="flex items-center gap-3"><input type="checkbox" checked={s.pickup_enabled} onChange={(e) => setS({ ...s, pickup_enabled: e.target.checked })} className="w-4 h-4 accent-[#E6E2DD]" /><span className="text-sm text-[#565A61]">Permitir retiro en persona (CABA)</span></label>
        <div className="grid grid-cols-2 gap-4">
          <div><Label className={lbl}>CP de origen (desde dónde despachás)</Label><Input data-testid="ship-origin-cp" className={field} value={s.origin_postal_code || ""} onChange={(e) => setS({ ...s, origin_postal_code: e.target.value })} placeholder="Ej: 1414" /></div>
          <div><Label className={lbl}>Peso por pieza (kg)</Label><Input data-testid="ship-weight" type="number" step="0.1" className={field} value={s.default_weight_kg ?? 1} onChange={(e) => setS({ ...s, default_weight_kg: e.target.value })} /></div>
        </div>
        <p className="text-[11px] text-[#565A61]">CP de origen y peso se usan para cotizar en vivo con el transportista cuando lo actives abajo. Sin eso, se aplica el costo base/zonas.</p>
        <div>
          <Label className={lbl}>Zonas por provincia (sobrescriben el costo base)</Label>
          <div className="space-y-2 mt-2">
            {s.shipping_zones.map((z, i) => (
              <div key={i} className="flex gap-2">
                <Input className={`${field} mt-0 w-32`} placeholder="Nombre" value={z.name || ""} onChange={(e) => setZone(i, "name", e.target.value)} />
                <Input className={`${field} mt-0 flex-1`} placeholder="Provincias (coma)" value={(z.provinces || []).join(", ")} onChange={(e) => setZone(i, "provinces", e.target.value.split(",").map((x) => x.trim()).filter(Boolean))} />
                <Input className={`${field} mt-0 w-28`} type="number" placeholder="Costo" value={z.cost || ""} onChange={(e) => setZone(i, "cost", Number(e.target.value))} />
                <button onClick={() => setS({ ...s, shipping_zones: s.shipping_zones.filter((_, j) => j !== i) })} className="text-[#565A61] hover:text-[#56677A] px-2"><Trash2 size={16} /></button>
              </div>
            ))}
            <button onClick={() => setS({ ...s, shipping_zones: [...s.shipping_zones, { name: "", provinces: [], cost: 0 }] })} className="dossier-label text-[#565A61] hover:text-[#171719] inline-flex items-center gap-1"><Plus size={14} /> Agregar zona</button>
          </div>
        </div>
        <button data-testid="save-shipping" onClick={saveShipping} className="btn-ink px-6 py-3 dossier-label">Guardar costos</button>
      </div>

      <div className="space-y-4">
        <h3 className="font-display font-bold uppercase tracking-tight text-xl text-[#171719]">Transportistas (credenciales)</h3>
        <p className="text-xs text-[#565A61]">Cargá las credenciales de API de tu cuenta con cada correo y activalo. La generación automática de envíos se habilita al activar la integración con esas credenciales.</p>
        {Object.entries(carriers.fields).map(([k, flds]) => (
          <div key={k} className="museum-frame p-4" data-testid={`carrier-${k}`}>
            <label className="flex items-center justify-between mb-3">
              <span className="font-display font-bold uppercase tracking-tight text-[#171719]">{k}</span>
              <span className="flex items-center gap-2"><input data-testid={`carrier-${k}-enabled`} type="checkbox" checked={!!carriers[k]?.enabled} onChange={(e) => setCarriers({ ...carriers, [k]: { ...carriers[k], enabled: e.target.checked } })} className="w-4 h-4 accent-[#72B078]" /><span className="dossier-label text-[#565A61]">activo</span></span>
            </label>
            <div className="grid grid-cols-2 gap-2">
              {flds.map((fld) => (
                <div key={fld}><Label className={lbl}>{fld}</Label><Input className={field} value={carriers[k]?.credentials?.[fld] || ""} onChange={(e) => setCarriers({ ...carriers, [k]: { ...carriers[k], credentials: { ...(carriers[k]?.credentials || {}), [fld]: e.target.value } } })} /></div>
              ))}
            </div>
          </div>
        ))}
        <button data-testid="save-carriers" onClick={saveCarriers} className="btn-ink px-6 py-3 dossier-label">Guardar credenciales</button>
      </div>
    </div>
  );
}

function ContenidoTab() {
  const [home, setHome] = useState({ hero_title: "", hero_subtitle: "", hero_image: "", manifesto: "", creator_bio: "" });
  const [legal, setLegal] = useState({ privacy: "", terms: "", returns: "" });
  const [ui, setUi] = useState({});
  const [uiOpen, setUiOpen] = useState(false);
  const [gal, setGal] = useState(Array(6).fill(""));

  useEffect(() => {
    api.get("/content/home").then((r) => setHome((h) => ({ ...h, ...r.data }))).catch(() => {});
    api.get("/content/legal").then((r) => setLegal((l) => ({ ...l, ...r.data }))).catch(() => {});
    api.get("/content/ui").then((r) => setUi(r.data || {})).catch(() => {});
    api.get("/content/gallery").then((r) => setGal((p) => { const n = [...p]; (r.data.images || []).forEach((u, i) => { if (i < 6) n[i] = u; }); return n; })).catch(() => {});
  }, []);

  const saveHome = async () => { try { await api.put("/admin/content/home", home); toast.success("Inicio actualizado"); } catch (e) { toast.error(errMsg(e)); } };
  const saveLegal = async () => { try { await api.put("/admin/content/legal", legal); toast.success("Textos legales actualizados"); } catch (e) { toast.error(errMsg(e)); } };
  const saveUi = async () => { try { await api.put("/admin/content/ui", { texts: ui }); toast.success("Textos de la web actualizados"); } catch (e) { toast.error(errMsg(e)); } };
  const saveGal = async () => { try { await api.put("/admin/content/gallery", { images: gal }); toast.success("Fotos guardadas"); } catch (e) { toast.error(errMsg(e)); } };

  return (
    <div className="max-w-5xl">
      <div className="museum-frame p-5 mb-10" data-testid="ui-texts-editor">
        <button data-testid="toggle-ui-texts" onClick={() => setUiOpen((o) => !o)} className="w-full flex items-center justify-between">
          <h3 className="font-display font-bold uppercase tracking-tight text-xl text-[#171719]">Textos de la web (botones y leyendas)</h3>
          <span className="dossier-label text-[#565A61]">{uiOpen ? "ocultar −" : "editar +"}</span>
        </button>
        <p className="text-xs text-[#565A61] mt-2">Todo lo que ves acá lo podés cambiar: aparece con el texto actual. Si borrás uno, vuelve al texto original.</p>
        {uiOpen && (
          <div className="mt-5 space-y-4">
            {UI_FIELDS.map(([key, label, long]) => (
              <div key={key}>
                <Label className={lbl}>{label}</Label>
                {long ? (
                  <Textarea rows={2} className={field} data-testid={`ui-text-${key}`} value={ui[key] || ""} placeholder={UI_DEFAULTS[key]} onChange={(e) => setUi({ ...ui, [key]: e.target.value })} />
                ) : (
                  <Input className={field} data-testid={`ui-text-${key}`} value={ui[key] || ""} placeholder={UI_DEFAULTS[key]} onChange={(e) => setUi({ ...ui, [key]: e.target.value })} />
                )}
              </div>
            ))}
            <button data-testid="save-ui-texts" onClick={saveUi} className="btn-ink px-6 py-3 dossier-label">Guardar textos</button>
          </div>
        )}
      </div>
      <div className="museum-frame p-5 mb-10" data-testid="photos-editor">
        <h3 className="font-display font-bold uppercase tracking-tight text-xl text-[#171719]">Fotos de la página</h3>
        <p className="text-xs text-[#565A61] mt-2">Galería del inicio (va debajo de la presentación, 3 y 3 bien pegadas). Podés subir fotos desde tu celular o pegar un enlace. Si dejás un casillero vacío, se ve la foto de muestra.</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-5">
          {gal.map((u, i) => (
            <div key={i} className="space-y-2" data-testid={`photo-slot-${i}`}>
              <div className="aspect-square bg-[#CFD1D6] overflow-hidden"><img src={u || GALLERY_DEFAULTS[i]} alt="" className={`w-full h-full object-cover ${u ? "" : "opacity-40"}`} /></div>
              <div className="flex gap-2">
                <Input className={`${field} text-xs`} data-testid={`photo-url-${i}`} value={u} placeholder={`foto ${i + 1}`} onChange={(e) => setGal((p) => p.map((x, j) => j === i ? e.target.value : x))} />
                <UploadBtn onDone={(url) => setGal((p) => p.map((x, j) => j === i ? url : x))} />
              </div>
            </div>
          ))}
        </div>
        <button data-testid="save-gallery" onClick={saveGal} className="btn-ink px-6 py-3 dossier-label mt-5">Guardar fotos</button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
      <div className="space-y-4">
        <h3 className="font-display font-bold uppercase tracking-tight text-xl text-[#171719]">Inicio</h3>
        <div><Label className={lbl}>Título del hero</Label><Input className={field} value={home.hero_title} onChange={(e) => setHome({ ...home, hero_title: e.target.value })} /></div>
        <div><Label className={lbl}>Subtítulo</Label><Textarea className={field} value={home.hero_subtitle} onChange={(e) => setHome({ ...home, hero_subtitle: e.target.value })} /></div>
        <div><Label className={lbl}>Imagen del hero (opcional, dejá vacío para usar la actual)</Label>
          <div className="flex gap-2 items-center">
            <Input className={field} data-testid="home-hero-image" value={home.hero_image || ""} placeholder="/hero/foto1.webp" onChange={(e) => setHome({ ...home, hero_image: e.target.value })} />
            <UploadBtn label="Subir" onDone={(url) => setHome({ ...home, hero_image: url })} />
          </div>
        </div>
        <div><Label className={lbl}>Manifiesto</Label><Textarea rows={4} className={field} value={home.manifesto} onChange={(e) => setHome({ ...home, manifesto: e.target.value })} /></div>
        <div><Label className={lbl}>Bio de la creadora</Label><Textarea rows={3} className={field} value={home.creator_bio} onChange={(e) => setHome({ ...home, creator_bio: e.target.value })} /></div>
        <button data-testid="save-home" onClick={saveHome} className="btn-ink px-6 py-3 dossier-label">Guardar inicio</button>
      </div>
      <div className="space-y-4">
        <h3 className="font-display font-bold uppercase tracking-tight text-xl text-[#171719]">Textos legales</h3>
        <div><Label className={lbl}>Privacidad</Label><Textarea rows={4} className={field} value={legal.privacy} onChange={(e) => setLegal({ ...legal, privacy: e.target.value })} /></div>
        <div><Label className={lbl}>Condiciones de compra</Label><Textarea rows={4} className={field} value={legal.terms} onChange={(e) => setLegal({ ...legal, terms: e.target.value })} /></div>
        <div><Label className={lbl}>Cambios y devoluciones</Label><Textarea rows={4} className={field} value={legal.returns} onChange={(e) => setLegal({ ...legal, returns: e.target.value })} /></div>
        <button data-testid="save-legal" onClick={saveLegal} className="btn-ink px-6 py-3 dossier-label">Guardar legales</button>
      </div>
      </div>
    </div>
  );
}

function AjustesTab() {
  const [s, setS] = useState({ currency: "ARS", pickup_enabled: true, contact_email: "", contact_whatsapp: "", instagram: "", pinterest: "", address: "", shipping_zones: [], low_stock_threshold: 5, events_enabled: false, style_mix_enabled: false, releases_enabled: false, historic_enabled: false, creator_enabled: false, enabled_categories: ["denim", "accesorios"] });
  useEffect(() => { api.get("/settings").then((r) => setS((p) => ({ ...p, ...r.data, low_stock_threshold: r.data.low_stock_threshold ?? 5, enabled_categories: (Array.isArray(r.data.enabled_categories) && r.data.enabled_categories.length > 0) ? r.data.enabled_categories : ["denim", "accesorios"] }))).catch(() => {}); }, []);
  const save = async () => { try { await api.put("/admin/settings", { ...s, low_stock_threshold: Number(s.low_stock_threshold || 5) }); toast.success("Ajustes guardados"); } catch (e) { toast.error(errMsg(e)); } };
  const CATS = [["denim", "Denim Intervenido"], ["intima", "Íntima / Corsetería"], ["accesorios", "Accesorios"], ["carteras", "Carteras / Bolsos"]];
  const toggleCat = (key) => setS((p) => {
    const cur = Array.isArray(p.enabled_categories) ? [...p.enabled_categories] : [];
    const next = cur.includes(key) ? cur.filter((k) => k !== key) : [...cur, key];
    return { ...p, enabled_categories: next };
  });
  return (
    <div className="max-w-lg space-y-4">
      <div className="museum-frame p-5 space-y-4" data-testid="visibility-settings">
        <div className="dossier-label text-[#565A61]">Secciones visibles en la web</div>
        <div className="flex items-center gap-3">
          <input id="set-releases" data-testid="set-releases" type="checkbox" checked={!!s.releases_enabled} onChange={(e) => setS({ ...s, releases_enabled: e.target.checked })} className="w-4 h-4" />
          <Label htmlFor="set-releases" className="text-sm text-[#171719]">Solapa «Lista de espera» / Liberaciones (próximos lanzamientos con aviso por mail)</Label>
        </div>
        <div className="flex items-center gap-3">
          <input id="set-creator" data-testid="set-creator" type="checkbox" checked={!!s.creator_enabled} onChange={(e) => setS({ ...s, creator_enabled: e.target.checked })} className="w-4 h-4" />
          <Label htmlFor="set-creator" className="text-sm text-[#171719]">Solapa «Camila Guerra» (Archivo VIP: menú, home y pie de página)</Label>
        </div>
        <div className="flex items-center gap-3">
          <input id="set-historic" data-testid="set-historic" type="checkbox" checked={!!s.historic_enabled} onChange={(e) => setS({ ...s, historic_enabled: e.target.checked })} className="w-4 h-4" />
          <Label htmlFor="set-historic" className="text-sm text-[#171719]">Solapa «Histórico» en el catálogo (ediciones agotadas)</Label>
        </div>
        <div className="flex items-center gap-3">
          <input id="set-events" data-testid="set-events" type="checkbox" checked={!!s.events_enabled} onChange={(e) => setS({ ...s, events_enabled: e.target.checked })} className="w-4 h-4" />
          <Label htmlFor="set-events" className="text-sm text-[#171719]">Sección de eventos (menú + página)</Label>
        </div>
        <div className="flex items-center gap-3">
          <input id="set-stylemix" data-testid="set-stylemix" type="checkbox" checked={!!s.style_mix_enabled} onChange={(e) => setS({ ...s, style_mix_enabled: e.target.checked })} className="w-4 h-4" />
          <Label htmlFor="set-stylemix" className="text-sm text-[#171719]">Sección de mezclas de estilos («La contradicción es parte de la identidad»)</Label>
        </div>
        <div>
          <Label className={lbl}>Categorías visibles en el archivo (sin marcar = todas)</Label>
          <div className="grid grid-cols-2 gap-2 mt-2">
            {CATS.map(([key, label]) => (
              <div key={key} className="flex items-center gap-2">
                <input id={`cat-${key}`} data-testid={`set-cat-${key}`} type="checkbox" checked={(s.enabled_categories || []).includes(key)} onChange={() => toggleCat(key)} className="w-4 h-4" />
                <Label htmlFor={`cat-${key}`} className="text-sm text-[#171719]">{label}</Label>
              </div>
            ))}
          </div>
          <p className="text-[11px] text-[#565A61] mt-2">Marcá las categorías que se ven en la web. Las ocultas siguen administrables acá y sus piezas no se pierden.</p>
        </div>
      </div>
      <div><Label className={lbl}>Email de contacto</Label><Input data-testid="set-email" className={field} value={s.contact_email} onChange={(e) => setS({ ...s, contact_email: e.target.value })} /></div>
      <div><Label className={lbl}>WhatsApp</Label><Input className={field} value={s.contact_whatsapp} onChange={(e) => setS({ ...s, contact_whatsapp: e.target.value })} /></div>
      <div><Label className={lbl}>Instagram (sin @)</Label><Input className={field} value={s.instagram} onChange={(e) => setS({ ...s, instagram: e.target.value })} /></div>
      <div><Label className={lbl}>Pinterest</Label><Input className={field} value={s.pinterest} onChange={(e) => setS({ ...s, pinterest: e.target.value })} /></div>
      <div><Label className={lbl}>Dirección</Label><Input className={field} value={s.address} onChange={(e) => setS({ ...s, address: e.target.value })} /></div>
      <div><Label className={lbl}>Alerta de stock bajo (avisar cuando queden ≤ ejemplares)</Label><Input data-testid="set-low-stock" type="number" min="1" className={field} value={s.low_stock_threshold ?? 5} onChange={(e) => setS({ ...s, low_stock_threshold: e.target.value })} /></div>
      <button data-testid="save-settings" onClick={save} className="btn-ink px-6 py-3 dossier-label">Guardar ajustes</button>
    </div>
  );
}

const INV_STATUS = { pending: "Pendiente", processing: "Procesando", authorized: "Autorizada", pdf_ready: "PDF listo", emailed: "Enviada", rejected: "Rechazada", disabled: "Apagada" };

const STAGES = [
  ["exhibicion", "Exhibición", "Pieza de archivo: sin precios, sin talles, sin compra. Solo galería + botón QUIERO ESTA PIEZA + contador público."],
  ["acceso_anticipado", "Acceso anticipado", "Se revelan precios y talles. Comprar solo con el enlace personal enviado a las registradas de cada pieza."],
  ["venta_publica", "Venta pública", "La tienda abre para todos: precios, talles y compra sin restricciones."],
];
const COUNTER_MODES_UI = [["exact", "Cifra exacta", "128 PERSONAS INTERESADAS"], ["rounded", "Cifra redondeada", "120+ PERSONAS INTERESADAS"], ["indicator", "Indicador sin cifra", "INTERÉS ALTO"]];

function LanzamientoTab() {
  const [d, setD] = useState(null);
  const [stage, setStage] = useState("exhibicion");
  const [cMode, setCMode] = useState("exact");
  const [filterPiece, setFilterPiece] = useState("");
  const load = () => Promise.all([
    api.get("/admin/interest", { params: filterPiece ? { product_id: filterPiece } : {} }),
    api.get("/settings"),
  ]).then(([i, s]) => { setD({ ...i.data, settings: s.data }); setStage(s.data.sales_stage || "exhibicion"); setCMode(s.data.counter_display || "exact"); }).catch(() => {});
  useEffect(() => { load(); }, [filterPiece]);
  if (!d) return <p className="text-[#565A61]">Cargando lanzamiento…</p>;
  const saveSettings = async (patch, msg) => {
    try {
      const cur = (await api.get("/settings")).data;
      await api.put("/admin/settings", { ...cur, ...patch });
      toast.success(msg);
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const notify = async (pid) => { try { const r = await api.post(`/admin/products/${pid}/early-notify`); toast.success(`Enviados: ${r.data.sent} · fallidos: ${r.data.failed}`); } catch (e) { toast.error(errMsg(e)); } };
  const exportCsv = async () => {
    try {
      const r = await api.get("/admin/interest/export", { params: filterPiece ? { product_id: filterPiece } : {}, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a"); a.href = url; a.download = "interes-archivelab.csv"; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const maxDay = Math.max(1, ...(d.series || []).map((s) => s.count || 0));
  return (
    <div className="space-y-12" data-testid="lanzamiento-tab">
      <div>
        <div className="dossier-label text-[#565A61] mb-4">Etapa del lanzamiento</div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {STAGES.map(([key, title, desc]) => (
            <button key={key} data-testid={`stage-${key}`} onClick={() => saveSettings({ sales_stage: key }, `Etapa: ${title}`)}
              className={`museum-frame p-5 text-left transition-colors ${stage === key ? "border-[#171719]" : "hover:border-[#171719]"}`}>
              <div className="flex items-center gap-2">
                <span className={`w-2 h-2 rounded-full ${stage === key ? "bg-[#72B078]" : "bg-[#3A3A3A]"}`} />
                <span className="font-display text-lg text-[#171719] uppercase tracking-tight">{title}</span>
              </div>
              <p className="text-xs text-[#565A61] mt-2 leading-relaxed">{desc}</p>
            </button>
          ))}
        </div>
      </div>

      <div>
        <div className="dossier-label text-[#565A61] mb-4">Contador público por pieza</div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {COUNTER_MODES_UI.map(([key, title, preview]) => (
            <button key={key} data-testid={`counter-${key}`} onClick={() => saveSettings({ counter_display: key }, "Contador actualizado")}
              className={`museum-frame p-4 text-left transition-colors ${cMode === key ? "border-[#171719]" : "hover:border-[#171719]"}`}>
              <div className="text-sm text-[#171719]">{title}</div>
              <div className="dossier-label text-[10px] text-[#4C7A51] mt-2">{preview}</div>
            </button>
          ))}
        </div>
        <p className="text-[11px] text-[#565A61] mt-3">La cifra (exacta o redondeada) sale siempre de los registros reales. El indicador no muestra número.</p>
      </div>

      <div>
        <div className="flex items-center justify-between mb-4">
          <div className="dossier-label text-[#565A61]">Interés por pieza</div>
          <button data-testid="interest-export" onClick={exportCsv} className="btn-outline-ink px-5 py-2.5 dossier-label text-[11px]">Exportar CSV</button>
        </div>
        <div className="grid grid-cols-3 gap-3 mb-6">
          <div className="museum-frame p-4"><div className="dossier-label text-[10px] text-[#565A61]">Registros totales</div><div data-testid="interest-total" className="text-[#171719] text-lg mt-2">{d.kpis?.total_registrations ?? 0}</div></div>
          <div className="museum-frame p-4"><div className="dossier-label text-[10px] text-[#565A61]">Personas únicas (muestra)</div><div className="text-[#171719] text-lg mt-2">{d.kpis?.unique_people ?? 0}</div></div>
          <div className="museum-frame p-4"><div className="dossier-label text-[10px] text-[#565A61]">Piezas con interés</div><div className="text-[#171719] text-lg mt-2">{d.kpis?.pieces_with_interest ?? 0}</div></div>
        </div>
        {(d.summary || []).length === 0 ? (
          <p className="text-[#565A61] text-sm">Todavía no hay registros de interés.</p>
        ) : (
          <div className="space-y-2">
            {(d.summary || []).map((s, i) => (
              <div key={s.product_id} data-testid={`interest-row-${s.product_id}`} className="museum-frame p-4 flex items-center justify-between gap-3 flex-wrap">
                <div>
                  <div className="text-sm text-[#171719]">{s.piece_name}</div>
                  <div className="font-mono2 text-[10px] text-[#565A61]">{s.design_code}</div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="text-right">
                    <div className="text-[#171719] font-display text-xl">{s.unique_people}</div>
                    <div className="dossier-label text-[9px] text-[#565A61]">PERSONAS ÚNICAS</div>
                  </div>
                  <button data-testid={`early-notify-${s.product_id}`} onClick={() => notify(s.product_id)} className="btn-outline-ink px-4 py-2.5 dossier-label text-[10px]">Notificar acceso anticipado</button>
                  <button onClick={() => setFilterPiece(s.product_id)} className="dossier-label text-[10px] underline text-[#565A61] hover:text-[#171719]">Ver registradas</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div>
        <div className="dossier-label text-[#565A61] mb-4">Evolución de registros (14 días)</div>
        <div className="flex items-end gap-2 h-24 border-b border-[#C4C7CD] pb-1" data-testid="interest-evolution">
          {(d.series || []).map((s) => (
            <div key={s.day} className="flex-1 flex items-end h-full" title={`${s.day}: ${s.count}`}>
              <div className="w-full bg-[#72B078]/70 rounded-t" style={{ height: `${Math.max(3, Math.round((s.count / maxDay) * 100))}%` }} />
            </div>
          ))}
        </div>
        {(d.series || []).length === 0 && <p className="text-[#565A61] text-xs mt-2">Sin registros en los últimos 14 días.</p>}
      </div>

      <div>
        <div className="flex items-center justify-between mb-4">
          <div className="dossier-label text-[#565A61]">Registradas {filterPiece ? "· pieza filtrada" : ""} {filterPiece && <button onClick={() => setFilterPiece("")} className="underline ml-2">ver todas</button>}</div>
        </div>
        <div className="space-y-1">
          {(d.registrations || []).map((r) => (
            <div key={r.id || r.email} data-testid={`interest-reg-${r.email}`} className="flex items-center justify-between text-sm py-2 border-b border-[#C9CBD1]">
              <div>
                <span className="text-[#2E2E31]">{r.name || "—"} <span className="text-[#858A91] text-xs">· {r.email}</span></span>
                <div className="text-[10px] text-[#565A61] font-mono2">{r.piece_name} · {String(r.created_at || "").slice(0, 10)} {r.whatsapp ? `· WSP ${r.whatsapp}` : ""}</div>
              </div>
              <div className="flex gap-2 text-[10px]">
                <span className={`dossier-label px-2 py-0.5 ${r.consent_email ? "bg-[#1C241D] text-[#4C7A51]" : "bg-[#2A2A2A] text-[#E8E9EB]"}`}>EMAIL</span>
                <span className={`dossier-label px-2 py-0.5 ${r.consent_whatsapp ? "bg-[#1C241D] text-[#4C7A51]" : "bg-[#2A2A2A] text-[#E8E9EB]"}`}>WSP</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const EM_VARS = "{{nombre}} · {{email}} · {{total}} · {{items_html}} · {{pedido_id}} · {{link_mi_archivo}} · {{link_archivo}}";

function TemplateCard({ tpl, onSave }) {
  const [t, setT] = useState(tpl);
  useEffect(() => { setT(tpl); }, [tpl]);
  const save = () => onSave(t);
  return (
    <div className="museum-frame p-5" data-testid={`em-tpl-${t.key}`}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-sm text-[#171719]">{t.name}</div>
          <div className="text-[11px] text-[#565A61] mt-1">{t.description}</div>
        </div>
        <label className="flex items-center gap-2 cursor-pointer">
          <input data-testid={`em-tpl-enabled-${t.key}`} type="checkbox" checked={!!t.enabled} onChange={(e) => setT({ ...t, enabled: e.target.checked })} className="w-4 h-4" />
          <span className="dossier-label text-[10px] text-[#565A61]">{t.enabled ? "Activa" : "Apagada"}</span>
        </label>
      </div>
      <div className="mt-4 space-y-3">
        <div>
          <Label className={lbl}>Asunto</Label>
          <Input data-testid={`em-tpl-subject-${t.key}`} className={field} value={t.subject} onChange={(e) => setT({ ...t, subject: e.target.value })} />
        </div>
        <div>
          <Label className={lbl}>Contenido del mail (texto o HTML simple)</Label>
          <textarea data-testid={`em-tpl-body-${t.key}`} value={t.body_html} onChange={(e) => setT({ ...t, body_html: e.target.value })}
            rows={7} className={`${field} mt-0 w-full block min-h-[130px] leading-relaxed`} />
        </div>
        <div className="font-mono2 text-[10px] text-[#565A61] leading-relaxed">Variables: {EM_VARS}</div>
        <button data-testid={`em-tpl-save-${t.key}`} onClick={save} className="btn-outline-ink px-5 py-2.5 dossier-label text-[11px]">Guardar plantilla</button>
      </div>
    </div>
  );
}

function EmailsTab() {
  const [data, setData] = useState(null);
  const [camp, setCamp] = useState({ name: "", subject: "", body_html: "", audience: "suscriptas", scheduled_at: "" });
  const [newSub, setNewSub] = useState("");
  const [testBusy, setTestBusy] = useState(false);
  const load = () => api.get("/admin/email").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!data) return <p className="text-[#565A61]">Cargando emails…</p>;
  const saveTemplate = async (t) => { try { await api.put(`/admin/email/templates/${t.key}`, { subject: t.subject, body_html: t.body_html, enabled: t.enabled }); toast.success("Plantilla guardada"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const createCampaign = async (sendNow) => {
    try {
      const payload = { ...camp, scheduled_at: sendNow ? null : (camp.scheduled_at ? new Date(camp.scheduled_at).toISOString() : null) };
      if (sendNow || !camp.scheduled_at) payload.scheduled_at = null;
      const r = await api.post("/admin/email/campaigns", payload);
      if (sendNow) { await api.post(`/admin/email/campaigns/${r.data.id}/send`); toast.success("Campaña enviándose…"); }
      else toast.success("Campaña programada");
      setCamp({ name: "", subject: "", body_html: "", audience: "suscriptas", scheduled_at: "" });
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const campAction = async (id, action) => { try { await api.post(`/admin/email/campaigns/${id}/${action}`); toast.success("Listo"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const deleteCamp = async (id) => { try { await api.delete(`/admin/email/campaigns/${id}`); toast.success("Eliminada"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const addSub = async () => { try { await api.post("/admin/email/subscribers", { email: newSub }); setNewSub(""); toast.success("Suscriptora agregada"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const delSub = async (id) => { try { await api.delete(`/admin/email/subscribers/${id}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  const CAMP_STATUS = { draft: "Borrador", scheduled: "Programada", sending: "Enviando…", sent: "Enviada", failed: "Falló", cancelled: "Cancelada" };
  return (
    <div className="space-y-12" data-testid="email-marketing">
      <div className={`museum-frame p-4 text-sm ${data.service_ok ? "border-[#1C241D]" : "border-[#3A1515]"}`} data-testid="em-service">
        {data.service_ok
          ? <span className="text-[#4C7A51]">● Servicio de email activo — los mails se están enviando.</span>
          : <span className="text-[#565A61]">● Servicio de email sin clave (EMERGENT_EMAIL_KEY) — hasta que esté activa, los mails se preparan pero no se envían. En el sitio publicado la clave viaja con el deploy.</span>}
        <span className="text-[#565A61] ml-3">Suscriptoras activas: <b data-testid="em-subs-count">{data.subscribers_count}</b></span>
      </div>
      <div className="mt-3">
        <button data-testid="em-test-send" disabled={testBusy} onClick={async () => { setTestBusy(true); try { const r = await api.post("/admin/email/test"); toast.success(`Enviado a ${r.data.to} · revisá tu casilla`); } catch (e) { toast.error(errMsg(e)); } setTestBusy(false); }} className="btn-outline-ink px-4 py-2 dossier-label disabled:opacity-50">{testBusy ? "Enviando…" : "Enviar email de prueba"}</button>
      </div>

      <div>
        <div className="dossier-label text-[#565A61] mb-4">Mails automáticos de la compra</div>
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
          {Object.values(data.templates).map((tpl) => <TemplateCard key={tpl.key} tpl={tpl} onSave={saveTemplate} />)}
        </div>
      </div>

      <div>
        <div className="dossier-label text-[#565A61] mb-4">Nuevo ingreso / campaña de marketing</div>
        <div className="museum-frame p-5 max-w-2xl space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div><Label className={lbl}>Nombre interno</Label><Input data-testid="em-camp-name" className={field} value={camp.name} onChange={(e) => setCamp({ ...camp, name: e.target.value })} placeholder="Ej: Ingreso Nueva Serie Denim" /></div>
            <div><Label className={lbl}>Audiencia</Label>
              <select data-testid="em-camp-audience" value={camp.audience} onChange={(e) => setCamp({ ...camp, audience: e.target.value })} className={`${field} mt-0 h-9 px-2 rounded-md border text-sm`}>
                <option value="suscriptas">Suscriptoras de la lista</option>
                <option value="compradoras">Compradoras</option>
                <option value="lista_espera">Listas de espera</option>
              </select>
            </div>
          </div>
          <div><Label className={lbl}>Asunto</Label><Input data-testid="em-camp-subject" className={field} value={camp.subject} onChange={(e) => setCamp({ ...camp, subject: e.target.value })} /></div>
          <div><Label className={lbl}>Mensaje (texto o HTML simple)</Label>
            <textarea data-testid="em-camp-body" rows={6} value={camp.body_html} onChange={(e) => setCamp({ ...camp, body_html: e.target.value })} className={`${field} mt-0 min-h-[110px]`} placeholder="Hola, ingresó al archivo la pieza que estabas esperando…" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 items-end">
            <div><Label className={lbl}>Programar (opcional)</Label><Input data-testid="em-camp-when" type="datetime-local" className={field} value={camp.scheduled_at} onChange={(e) => setCamp({ ...camp, scheduled_at: e.target.value })} /></div>
            <div className="flex gap-3">
              <button data-testid="em-camp-send" onClick={() => createCampaign(true)} className="btn-ink px-5 py-3 dossier-label text-[11px]">Enviar ahora</button>
              <button data-testid="em-camp-schedule" onClick={() => createCampaign(false)} className="btn-outline-ink px-5 py-3 dossier-label text-[11px]">Programar</button>
            </div>
          </div>
          <div className="font-mono2 text-[10px] text-[#565A61]">Variables: {EM_VARS} · toda campaña lleva link de baja automático</div>
        </div>
      </div>

      <div>
        <div className="dossier-label text-[#565A61] mb-4">Campañas</div>
        {(data.campaigns || []).length === 0 && <p className="text-[#565A61] text-sm">Sin campañas todavía.</p>}
        <div className="space-y-2">
          {(data.campaigns || []).map((c) => (
            <div key={c.id} data-testid={`em-camp-${c.id}`} className="museum-frame p-4 flex items-center justify-between gap-3 flex-wrap">
              <div>
                <div className="text-sm text-[#171719]">{c.name}</div>
                <div className="text-[11px] text-[#565A61] mt-1">{c.subject} · {c.audience}{c.scheduled_at ? ` · ${new Date(c.scheduled_at).toLocaleString("es-AR")}` : ""}</div>
              </div>
              <div className="flex items-center gap-3">
                <span className={`dossier-label text-[10px] px-2 py-1 ${c.status === "sent" ? "bg-[#1C241D] text-[#4C7A51]" : c.status === "failed" ? "bg-[#2A2A2A] text-[#E8E9EB]" : "bg-[#2A2A2A] text-[#E8E9EB]"}`}>
                  {CAMP_STATUS[c.status] || c.status}{c.stats?.total ? ` · ${c.stats.sent}/${c.stats.total}` : ""}
                </span>
                {["draft", "scheduled"].includes(c.status) && <button data-testid={`em-camp-sendnow-${c.id}`} onClick={() => campAction(c.id, "send")} className="dossier-label text-[10px] underline text-[#565A61] hover:text-[#171719]">Enviar ahora</button>}
                {c.status === "scheduled" && <button onClick={() => campAction(c.id, "cancel")} className="dossier-label text-[10px] underline text-[#565A61]">Cancelar</button>}
                <button onClick={() => deleteCamp(c.id)} className="dossier-label text-[10px] underline text-[#565A61] hover:text-[#56677A]">Borrar</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="dossier-label text-[#565A61] mb-4">Suscriptoras</div>
        <div className="flex gap-2 max-w-md mb-4">
          <Input data-testid="em-sub-email" placeholder="nueva@email.com" className={field} value={newSub} onChange={(e) => setNewSub(e.target.value)} />
          <button data-testid="em-sub-add" onClick={addSub} className="btn-outline-ink px-5 py-3 dossier-label text-[11px] whitespace-nowrap">Agregar</button>
        </div>
        <div className="space-y-1">
          {(data.subscribers || []).map((s) => (
            <div key={s.id || s.email} data-testid={`em-sub-${s.email}`} className="flex items-center justify-between text-sm py-2 border-b border-[#C9CBD1] max-w-2xl">
              <span className={s.unsubscribed ? "text-[#858A91] line-through" : "text-[#2E2E31]"}>{s.email} <span className="text-[#858A91] text-[10px]">({s.source || "manual"})</span></span>
              <button onClick={() => delSub(s.id)} className="dossier-label text-[10px] text-[#565A61] hover:text-[#56677A]">Quitar</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function MetricsTab() {
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)).catch(() => {}); setLoading(false); }, []);
  if (loading || !d) return <p className="text-[#565A61]">Cargando métricas…</p>;
  const k = d.kpis || {};
  const kpis = [
    ["Ventas totales", formatARS(k.revenue_total || 0), "dash-revenue-total"],
    ["Últimos 30 días", formatARS(k.revenue_30d || 0), "dash-revenue-30d"],
    ["Últimos 7 días", formatARS(k.revenue_7d || 0), "dash-revenue-7d"],
    ["Hoy", formatARS(k.revenue_today || 0), "dash-revenue-today"],
    ["Pedidos pagados", String(k.orders_total ?? 0), "dash-orders"],
    ["Ticket promedio", formatARS(k.avg_ticket || 0), "dash-avg-ticket"],
  ];
  const maxRev = Math.max(1, ...(d.series || []).map((s) => s.revenue || 0));
  return (
    <div className="space-y-10" data-testid="metrics-dashboard">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {kpis.map(([label, value, tid]) => (
          <div key={label} className="museum-frame p-4">
            <div className="dossier-label text-[#565A61] text-[10px]">{label}</div>
            <div data-testid={tid} className="text-[#171719] text-lg mt-2 truncate" title={value}>{value}</div>
          </div>
        ))}
      </div>

      <div>
        <div className="dossier-label text-[#565A61] mb-4">Ventas últimos 14 días</div>
        <div data-testid="dash-chart" className="flex items-end gap-2 h-40 border-b border-[#C4C7CD] pb-1">
          {(d.series || []).map((s) => (
            <div key={s.date} className="flex-1 flex flex-col items-center justify-end h-full group" title={`${s.date}: ${formatARS(s.revenue)} · ${s.orders} pedido(s)`}>
              <span className="text-[10px] text-[#565A61] mb-1 opacity-0 group-hover:opacity-100 transition-opacity">{s.revenue > 0 ? formatARS(s.revenue) : ""}</span>
              <div className="w-full bg-[#171719] group-hover:bg-[#56677A] transition-colors rounded-t" style={{ height: `${Math.max(2, Math.round((s.revenue / maxRev) * 100))}%` }} />
            </div>
          ))}
        </div>
        <div className="flex gap-2 mt-2">
          {(d.series || []).map((s) => <div key={s.date} className="flex-1 text-center text-[9px] dossier-label text-[#858A91]">{s.date}</div>)}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="dossier-label text-[#565A61] mb-4">Más vendidas</div>
          {(d.top_products || []).length === 0 && <p className="text-[#565A61] text-sm">Todavía no hay ventas registradas.</p>}
          <div className="space-y-2">
            {(d.top_products || []).map((p, i) => (
              <div key={p.product_id || p.name} data-testid={`dash-top-${i}`} className="museum-frame p-4 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <span className="font-display text-2xl text-[#858A91]">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <div className="text-sm text-[#171719]">{p.name}</div>
                    {p.design_code && <div className="font-mono2 text-[10px] text-[#565A61]">{p.design_code}</div>}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-[#171719]">{p.units} vendida{p.units === 1 ? "" : "s"}</div>
                  <div className="text-xs text-[#565A61]">{formatARS(p.revenue)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="dossier-label text-[#565A61] mb-4">Stock bajo (≤ {d.low_stock?.[0]?.threshold ?? 5} disponibles)</div>
          {(d.low_stock || []).length === 0 && <p className="text-[#565A61] text-sm">Todas las piezas con stock sano.</p>}
          <div className="space-y-2">
            {(d.low_stock || []).map((p) => (
              <div key={p.id} data-testid={`dash-lowstock-${p.design_code || p.id}`} className="museum-frame p-4 flex items-center justify-between">
                <div>
                  <div className="text-sm text-[#171719]">{p.name}</div>
                  <div className="font-mono2 text-[10px] text-[#565A61]">{p.design_code}</div>
                </div>
                <span className="flex items-center gap-2">
                    <span data-testid={`stock-info-${p.id}`} className="dossier-label text-[10px] text-[#565A61]">{p.available_total} libre{p.available_total === 1 ? "" : "s"} · {p.sold_total || 0} vendida{(p.sold_total || 0) === 1 ? "" : "s"}</span>
                    {p.available_total === 0 && <span className="dossier-label px-3 py-1 bg-[#171719]/10 text-[#565A61]">sin stock</span>}
                  </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="museum-frame p-4"><div className="dossier-label text-[#565A61] text-[10px]">Facturas pendientes</div><div data-testid="dash-pending-invoices" className="text-[#171719] text-lg mt-2">{d.extras?.pending_invoices ?? 0}</div></div>
        <div className="museum-frame p-4"><div className="dossier-label text-[#565A61] text-[10px]">Envíos por despachar</div><div data-testid="dash-pending-ship" className="text-[#171719] text-lg mt-2">{d.extras?.pending_ship ?? 0}</div></div>
        <div className="museum-frame p-4"><div className="dossier-label text-[#565A61] text-[10px]">Lista de espera (total)</div><div data-testid="dash-waitlist" className="text-[#171719] text-lg mt-2">{d.extras?.waitlist_total ?? 0}</div></div>
      </div>
    </div>
  );
}

function FacturacionTab() {
  const [c, setC] = useState({ enabled: false, env: "homologacion", cuit: "", pto_vta: 1, iva_pct: 21, brand_name: "ARCHIVE LAB", brand_address: "Buenos Aires, Argentina", brand_legal: "" });
  const [invs, setInvs] = useState([]);
  const [certOk, setCertOk] = useState(false);
  const load = () => api.get("/admin/invoicing").then((r) => { const cfg = r.data.config || {}; setC((p) => ({ ...p, ...cfg })); setInvs(r.data.invoices || []); setCertOk(!!cfg.cert_ok); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async () => { try { await api.put("/admin/invoicing", c); toast.success("Facturación guardada"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const retry = async (orderId) => { try { await api.post(`/admin/orders/${orderId}/invoice/retry`); toast.success("Reprocesando…"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-10 max-w-2xl">
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <input id="inv-enabled" data-testid="inv-enabled" type="checkbox" checked={!!c.enabled} onChange={(e) => setC({ ...c, enabled: e.target.checked })} className="w-4 h-4" />
          <Label htmlFor="inv-enabled" className="text-sm text-[#171719]">Facturación electrónica activa · Factura B automática al confirmarse el pago</Label>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div><Label className={lbl}>CUIT (sin guiones)</Label><Input data-testid="inv-cuit" className={field} value={c.cuit || ""} onChange={(e) => setC({ ...c, cuit: e.target.value })} /></div>
          <div><Label className={lbl}>Punto de venta</Label><Input data-testid="inv-pto-vta" type="number" min="1" className={field} value={c.pto_vta ?? 1} onChange={(e) => setC({ ...c, pto_vta: e.target.value })} /></div>
          <div><Label className={lbl}>Ambiente ARCA</Label>
            <select data-testid="inv-env" value={c.env || "homologacion"} onChange={(e) => setC({ ...c, env: e.target.value })} className={`${field} mt-0 h-9 px-2 rounded-md border text-sm`}>
              <option value="homologacion">Homologación (prueba)</option>
              <option value="produccion">Producción</option>
            </select>
          </div>
          <div><Label className={lbl}>IVA (%)</Label><Input type="number" step="0.5" className={field} value={c.iva_pct ?? 21} onChange={(e) => setC({ ...c, iva_pct: e.target.value })} /></div>
          <div><Label className={lbl}>Nombre fiscal (marca)</Label><Input className={field} value={c.brand_name || ""} onChange={(e) => setC({ ...c, brand_name: e.target.value })} /></div>
          <div><Label className={lbl}>Domicilio fiscal</Label><Input className={field} value={c.brand_address || ""} onChange={(e) => setC({ ...c, brand_address: e.target.value })} /></div>
        </div>
        <div><Label className={lbl}>Línea legal (opcional)</Label><Input className={field} value={c.brand_legal || ""} onChange={(e) => setC({ ...c, brand_legal: e.target.value })} /></div>
        <div className={`text-xs ${certOk ? "text-[#4C7A51]" : "text-[#565A61]"}`} data-testid="inv-cert-status">
          {certOk ? "Certificado ARCA detectado en el servidor." : "Falta certificado: configurar ARCA_CERT_PATH y ARCA_KEY_PATH en el entorno y reiniciar el backend."}
        </div>
        <button data-testid="inv-save" onClick={save} className="btn-ink px-6 py-3 dossier-label">Guardar facturación</button>
      </div>
      <div>
        <div className="dossier-label text-[#565A61] mb-3">Últimas facturas</div>
        {invs.length === 0 && <p className="text-[#565A61] text-sm">Todavía no hay facturas. Se generan automáticamente cuando se confirma un pago.</p>}
        <div className="space-y-2">
          {invs.map((i) => (
            <div key={i.id || i.order_id} data-testid={`inv-row-${i.order_id}`} className="museum-frame p-4 flex items-center justify-between gap-3 text-xs flex-wrap">
              <div className="font-mono2 text-[#2E2E31]">{i.numero ? `B ${String(i.pto_vta || c.pto_vta || 0).padStart(4, "0")}-${String(i.numero).padStart(8, "0")}` : i.order_id}</div>
              <div className="flex items-center gap-3">
                <span className={`dossier-label text-[10px] ${i.status === "emailed" ? "text-[#4C7A51]" : i.status === "rejected" ? "text-[#565A61]" : "text-[#565A61]"}`}>
                  {INV_STATUS[i.status] || i.status}{i.cae ? ` · CAE ${i.cae}` : ""}
                </span>
                {["pdf_ready", "emailed"].includes(i.status) && (
                  <a href={`${API}/orders/${i.order_id}/invoice.pdf`} target="_blank" rel="noreferrer" className="dossier-label text-[10px] underline text-[#171719]">PDF</a>
                )}
                {["pending", "rejected", "disabled"].includes(i.status) && (
                  <button data-testid={`inv-retry-${i.order_id}`} onClick={() => retry(i.order_id)} className="dossier-label text-[10px] underline text-[#565A61] hover:text-[#171719]">Reintentar</button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
